const theme = {
    palette: {
        primary: {
            main: '#0d8ca5',
        }
    },
    button:{
        borderRadius: '20px',
        activeBackgroundColor: '#0d8ca5',
        backgroundColor: '#f5f5f5',
        viewBackgroundColor: '#7c4dff',   
        editBackgroundColor: '#00bfa5',   
        deleteBackgroundColor: '#ff5252', 
    },
    table:{
        borderRadius: '20px',
        headerBgColor: '#f5f5f5',
    },
    dialog:{
        borderRadius: '20px',
        headerBgColor: '#f5f5f5',
        minWidth: '400px',
        footerBgColor: '#fafafa',
        avatar: {
            width: 80,
            height: 80,
        }
    },
    paper:{
        borderRadius: '20px',
        backgroundColor: '#ffffff',
    }
};
export default theme;